import { render, staticRenderFns } from "./ba.vue?vue&type=template&id=786e0eff&scoped=true"
import script from "./ba.vue?vue&type=script&lang=js"
export * from "./ba.vue?vue&type=script&lang=js"
import style0 from "./ba.vue?vue&type=style&index=0&id=786e0eff&prod&lang=less&scoped=true"
import style1 from "./ba.vue?vue&type=style&index=1&id=786e0eff&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786e0eff",
  null
  
)

export default component.exports